export const routesQueryKeys = {
  all: () => ["routes"] as const,
  lists: () => [...routesQueryKeys.all(), "list"] as const,
  list: () => [...routesQueryKeys.lists()] as const,
  details: () => [...routesQueryKeys.all(), "detail"] as const,
  detail: (id: string) => [...routesQueryKeys.details(), id] as const,
};
